import type { ChangeEvent, FC } from 'react';
import { useCallback } from 'react';
import ChevronDownIcon from '@untitled-ui/icons-react/build/esm/ChevronDown';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SvgIcon from '@mui/material/SvgIcon';
import { usePopover } from 'src/hooks/use-popover';
import { closeoutOptionalTestId, closeoutOptionTestId } from './test-ids';

// import { usePopover } from './hooks/use-popover';

interface MultiSelectProps {
  label: string;
  // Same as type as the value received above
  onChange?: (value: any[]) => void;
  options: { label: string; value: unknown }[];
  // This should accept string[], number[] or boolean[]
  value: any[];
  testId?: string;
}

export const MultiSelect: FC<MultiSelectProps> = (props) => {
  const { label, onChange, options, value = [], testId, ...other } = props;
  const popover = usePopover<HTMLButtonElement>();

  const handleValueChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      let newValue = [...value];

      if (event.target.checked) {
        newValue.push(event.target.value);
      } else {
        newValue = newValue.filter((item) => item !== event.target.value);
      }

      onChange?.(newValue);
    },
    [onChange, value]
  );

  return (
    <>
      <Button
        color="inherit"
        endIcon={
          <SvgIcon>
            <ChevronDownIcon />
          </SvgIcon>
        }
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        data-testid={closeoutOptionalTestId(testId)}
        {...other}
      >
        {label}
      </Button>
      <Menu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        //  The Years list runs back to 2000, so the menu has to scroll rather than fill the page.
        PaperProps={{ style: { width: 250, maxHeight: 320 } }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.label}
            data-testid={closeoutOptionTestId(testId, String(option.value))}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={value.includes(option.value)}
                  onChange={handleValueChange}
                  value={option.value}
                />
              }
              label={option.label}
              sx={{
                flexGrow: 1,
                mr: 0,
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
